import { createFileRoute } from '@tanstack/react-router';

import { Sorry } from '@/features/registration';

export const Route = createFileRoute('/sorry')({
	component: () => <Sorry />,
	head: () => ({
		meta: [
			{
				title: 'Sorry, we couldn’t find that page | ACCESS Research Platform',
			},
		],
	}),
});
